module.exports = __webpack_public_path__ + "img/统计椭圆形-白.245f313c.png";